import { Injectable } from '@angular/core';
import { IAddressData } from '@df/session/api/address-book/address';
import { addressNamePipe } from 'projects/app-default/src/app/common/address-name/address-name.pipe';

@Injectable({
    providedIn: 'root'
})
export class CheckoutAddressService {
    getMainLine(addressData: IAddressData): string {
        return addressNamePipe(addressData);
    }

    getAddressLines(addressData: IAddressData) {
        if (!addressData) {
            return [];
        }
        return [
            { fields: ['street_1', 'street_2'], glue: ', ' },
            { fields: ['city', 'postcode', 'region', 'country'], glue: ' ' }
        ]
            .map(i => this.filterAddressLine(addressData, i.fields, i.glue))
            .filter(i => !!i);
    }

    private filterAddressLine(addressData: IAddressData | undefined, fields: string[], glue: string = ' ') {
        return fields
            .map(field => (addressData ? addressData[field] : undefined))
            .filter(this.isAddressData)
            .join(glue);
    }

    private isAddressData = (addressData: IAddressData | undefined): addressData is IAddressData => !!addressData;
}
